"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62788],{

/***/ 62788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* provided dependency */ var process = __webpack_require__(34155);






var SharedHead = function(param) {
    var datas = param.datas;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var favicon = (datas === null || datas === void 0 ? void 0 : (ref = datas.data) === null || ref === void 0 ? void 0 : ref.favicon) ? datas.data.favicon : null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var pageRoute = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var basePath = 'https://' + (process.env.PUBLIC_DOMAIN || ( true ? window.location.host : 0));
        var locale = router.locale === router.defaultLocale ? '' : "/".concat(router.locale);
        var href = "".concat(basePath).concat(locale).concat(router.asPath);
        return href.endsWith('/') ? href.slice(0, -1) : href;
    }, [
        router.asPath,
        router.pathname,
        router.isReady
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1"
            }),
            (datas === null || datas === void 0 ? void 0 : (ref1 = datas.data) === null || ref1 === void 0 ? void 0 : ref1.meta_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (0,_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(datas === null || datas === void 0 ? void 0 : (ref2 = datas.data) === null || ref2 === void 0 ? void 0 : ref2.meta_url)
            }),
            (datas === null || datas === void 0 ? void 0 : (ref3 = datas.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.meta_image) === null || ref4 === void 0 ? void 0 : ref4.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: datas === null || datas === void 0 ? void 0 : (ref5 = datas.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.meta_image) === null || ref6 === void 0 ? void 0 : ref6.url,
                name: "image"
            }),
             false && /*#__PURE__*/ 0,
            (favicon === null || favicon === void 0 ? void 0 : favicon.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: favicon.url
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16 32x32 48x48",
                        href: favicon['small'].url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_3__["default"], {
                src: "https://unpkg.com/swiper@6.4.8/swiper-bundle.min.js"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (SharedHead);


/***/ })

}]);